import { render, staticRenderFns } from "./UserDashboards.vue?vue&type=template&id=7176554e&scoped=true"
import script from "./UserDashboards.vue?vue&type=script&lang=js"
export * from "./UserDashboards.vue?vue&type=script&lang=js"
import style0 from "./UserDashboards.vue?vue&type=style&index=0&id=7176554e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7176554e",
  null
  
)

export default component.exports